import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const Faqs = ({title, faqs}) => (
    <section className="seo faqs">
        <h2>{i18n.t('seo_sub_category.faqs.title', {sub_category_title: title})}</h2>
        <ul>
            {faqs.map((content, index) => (
                <li key={index}>
                    <h3>{content.question}</h3>
                    <p>{content.answer}</p>
                </li>
            ))}
        </ul>
    </section>
);

Faqs.propTypes = {
    title: PropTypes.string,
    faqs: PropTypes.array
};

Faqs.defaultProps = {
    title: '',
    faqs: []
};


export default Faqs;



// WEBPACK FOOTER //
// ./src/components/Faqs/index.js